import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import { usePrevious } from 'react-use';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import IconSearch from 'components/icons/IconSearch';
import { colorGrayLight2 } from 'styles/layout/colors';
import useScreen from 'hooks/useScreen';
import getShortPageName from './helpers/getShortPageName';
const DesktopProductListingSearchFilter = () => {
  const $ = _c(18);
  const {
    filters,
    pageName: t0,
    setCustomFilter
  } = useProductListingPageContext();
  const pageName = t0 === undefined ? "" : t0;
  const {
    isMobileOrTablet
  } = useScreen();
  let t1;
  if ($[0] !== pageName) {
    t1 = getShortPageName(pageName);
    $[0] = pageName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const shortPageName = t1;
  let t2;
  if ($[2] !== filters) {
    t2 = filters.find(_temp)?.value;
    $[2] = filters;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const valueInPageState = t2;
  const prevValueInPageState = usePrevious(valueInPageState);
  const [value, setValue] = useState(valueInPageState ?? "");
  let t3;
  if ($[4] !== prevValueInPageState || $[5] !== valueInPageState) {
    t3 = () => {
      setValue(latestValue => {
        if (prevValueInPageState && !valueInPageState && !!latestValue && latestValue === prevValueInPageState) {
          return "";
        }
        return latestValue;
      });
    };
    $[4] = prevValueInPageState;
    $[5] = valueInPageState;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== prevValueInPageState || $[8] !== value || $[9] !== valueInPageState) {
    t4 = [prevValueInPageState, value, valueInPageState];
    $[7] = prevValueInPageState;
    $[8] = value;
    $[9] = valueInPageState;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconSearch color={colorGrayLight2} height={20} />;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = !isMobileOrTablet ? `Search ${shortPageName}` : "Search";
  let t7;
  if ($[12] !== setCustomFilter) {
    t7 = event => {
      const updatedValue = event?.target?.value;
      setValue(updatedValue);
      setCustomFilter("search", updatedValue);
    };
    $[12] = setCustomFilter;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = value ?? null;
  let t9;
  if ($[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
    t9 = <LabeledTextInput action={t5} actionAlignment="left" data-xc="ProductListingSearchInput" label={t6} labelSize="sm" noMargin={true} onChange={t7} value={t8} />;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
export default DesktopProductListingSearchFilter;
function _temp(t0) {
  const {
    id
  } = t0;
  return id === "search";
}